module.exports = __webpack_public_path__ + "img/home_down_bg.cd17efcd.png";